import { createRoot } from 'react-dom/client';
import * as React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'

const appContainer = document.getElementById('tppApp')

function AppWithCallbackAfterRender() {
    return (
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>)
}

const root = createRoot(appContainer);
root.render(<AppWithCallbackAfterRender />);